import { IconButtonProps } from 'components/IconButton/Types'
import { comparer, computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { type DocStore } from 'stores/DocStore'
import { CollabItemInteractionButton } from '../CollabItemInteractionButton/CollabItemInteractionButton'

interface Props extends Partial<IconButtonProps> {
  uuids: string[]
  docStore: DocStore
}

export const TaskInteractionButton = observer(({ className, uuids, docStore, ...additonalProps }: Props) => {
  const tasks = computed(() => docStore.todos.filter((t) => t.uuid && uuids.includes(t.uuid)), {
    equals: comparer.structural,
  }).get()

  return (
    <CollabItemInteractionButton
      className={className}
      collabType="todo"
      items={tasks}
      selectFn={docStore.rootStore.todos.select}
      {...additonalProps}
    />
  )
})
